import React, { useEffect, useState } from "react";
import TimesheetLayout from "../TimesheetLayout";
import { Button, Modal, notification, Popover, Select } from "antd";
import axiosInstance from "../../../../../../Services/axiosCommon";
import { useNumber } from "../../../../../../Context/ProjectIdContext";
import { useLocation, useParams } from "react-router-dom";
import { GetAccess } from "../../../../../../Components/Utils/roles";
import ArrowLeft from "../../../../../../Components/Icons/ArrowLeft";
import ArrowRight from "../../../../../../Components/Icons/ArrowRight";
import { useFormik } from "formik";
import { NuTextArea } from "../../../../../../Components/Utils/Input";
import DeleteIcon from "../../../../../../Components/Icons/Delete";
import EditIcon from "../../../../../../Components/Icons/Edit";

function TimesheetsIndex() {
  const { officeId } = useParams();
  const { projectId } = useParams();
  const [projectList, setProjectList] = useState([]);
  const [firstProject, setFirstProject] = useState("");
  // const { number, updateNumber } = useNumber();
  const location = useLocation();
  const projectTask = location?.state?.projectTask || "";
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [monName, setMonName] = useState("");
  const [days, setDays] = useState([]);
  const [employeeAttendes, setEmployeeAttendes] = useState([]);
  console.log("bbb", currentMonth);

  const monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }

  function getMonth(value = "") {
    let displayMonth = monthList[value !== "" ? value : new Date().getMonth()];
    setMonName(displayMonth);
  }

  function getDayName(year, month, day) {
    const date = new Date(year, month, day);
    const dayName = date.toLocaleDateString("en-US", { weekday: "short" }); // 'short' for "Mon", "Tue", etc.
    return dayName;
  }

  useEffect(() => {
    getMonth(currentMonth);

    const daysInCurrentMonth = daysInMonth(currentYear, currentMonth);
    const daysArray = Array.from({ length: daysInCurrentMonth }, (_, i) => {
      return {
        // monthName: monName,
        dateNum: `${i + 1}`,
        dayName: getDayName(currentYear, currentMonth, i + 1),
      };
    });
    setDays(daysArray);
  }, [currentMonth, currentYear, monName]);

  const handlePrevMonth = () => {
    setCurrentMonth((prevMonth) => {
      if (prevMonth === 0) {
        setCurrentYear((prevYear) => prevYear - 1);
        return 11;
      }
      return prevMonth - 1;
    });
  };

  const handleNextMonth = () => {
    setCurrentMonth((nextMonth) => {
      if (nextMonth === 11) {
        setCurrentYear((nextYear) => nextYear + 1);
        return 0;
      }
      return nextMonth + 1;
    });
  };

  const handleYearChange = (event) => {
    setCurrentYear(parseInt(event.target.value, 10));
  };

  const handleMonthChange = (event) => {
    setCurrentMonth(parseInt(event.target.value, 10));
  };

  // async function getProject() {
  //   await axiosInstance
  //     .get(`/Team/getUserProjectId`)
  //     .then(async (res) => {
  //       if (number != 0) {
  //         setFirstProject(number);
  //       } else if (projectTask) {
  //         console.log("DD", projectTask);
  //         setFirstProject(projectTask);
  //         updateNumber(projectTask);
  //       } else {
  //         res?.data?.data[0] && setFirstProject(res?.data?.data[0]?.ProjectId);
  //         updateNumber(res?.data?.data[0]?.ProjectId);
  //         console.log("dd", res?.data?.data[0]?.ProjectId);
  //       }
  //       let list = res?.data?.data || [];
  //       let finalData = [];
  //       (await res?.data?.data) &&
  //         list.map((item, idx) => {
  //           finalData.push({
  //             value: item.ProjectId,
  //             label: item.ProjectName,
  //           });
  //         });
  //       setProjectList(finalData);

  //       // await res?.data?.Project && setTotalProject(res?.data?.totalProject);
  //       // console.log('====',res?.data?.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  async function getMembersByProject(projectId) {
    console.log("fgfd", projectId);
    await axiosInstance
      .get(
        `/Attendance/project/${projectId}/month/${
          currentMonth + 1
        }/year/${currentYear}`
      )
      .then((res) => {
        console.log("find", res?.data?.data);
        res?.data?.data && setEmployeeAttendes(res?.data?.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setEmployeeAttendes([]);
        }
        console.log(error);
      });
  }

  // function handleProjectChange(e) {
  //   setFirstProject(e);
  //   updateNumber(e);
  // }

  // useEffect(() => {
  //   getProject();
  // }, []);

  useEffect(() => {
    // if (firstProject) {
    getMembersByProject(projectId);
    // }
  }, [currentMonth, currentYear]);

  const [openAll, setOpenAll] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [editMode, setEditMode] = useState(false); 
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  
  const [create, setCreate] = useState({
    comments: "",
  });
   
  // function OpenFuction(id){
  //   setEmployeeId(id)
  //   setOpenAll(true)
  // }
  function OpenFunction(id, existingComment = "") {
    setEmployeeId(id);
    setCreate({ comments: existingComment || "" });
    setEditMode(!!existingComment); 
    setOpenAll(true);
  }
  

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: create,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      const apiUrl = editMode
        ? `/Attendance/edit-comment/${employeeId}`
        : `/Attendance/add-comment/${employeeId}`;
  
      const method = editMode ? "put" : "post";
  
      setIsLoading(true);
      axiosInstance[method](apiUrl, value)
        .then((res) => {
          if (res.status === 200 || res.status === 201 || res.data.status === true) {
            api.success({
              message: `Success`,
              description: res?.data?.msg || "Operation completed",
              placement: "bottomRight",
            });
            resetForm();
            setOpenAll(false);
            getMembersByProject(projectId); 
          } else {
            api.error({
              message: `Failed`,
              description: res?.data?.msg || "Something went wrong",
              placement: "bottomRight",
            });
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    },
  });
  
      
  
  function CloseFunction(){
    setCreate({
     comments:"",
    //  id:""
    })
    setEmployeeId("")
    setOpenAll(false)
  }

  const handleDeleteComment = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this comment?",
      width:"25%",
      centered:true,
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        axiosInstance
          .delete(`/Attendance/remove-comment/${employeeId}`)
          .then((res) => {
            if (res.status === 200 || res.data.status === true) {
              api.success({
                message: "Deleted",
                description: res?.data?.msg || "Comment deleted successfully",
                placement: "bottomRight",
              });
              getMembersByProject(projectId);
            }
          })
          .catch((err) => console.error(err));
      },
    });
  };
  
  return (
    <>
      <TimesheetLayout
        CreateAccess={GetAccess()}
        ImportAccess={GetAccess()}
        officeId={officeId}
        projectId={projectId}
      >
        <div className=" w-full rounded-lg flex justify-between items-center my-2">
          <div className="flex justify-start gap-2 ml-3">
            <p className=" text-xs font-semibold">
              Employees : {employeeAttendes.length}
            </p>
          </div>
          {/* <div className=" w-3/12 2xl:w-2/12">
          <Select
              style={{ width: "100%" }}
              options={projectList}
              value={projectList.find((i) => i.value == firstProject) || ""}
              disabled={projectList.length >= 2 ? false : true}
              // allowClear={formik.values[name]?true:false}
              // name={name}
              // placeholder={placeholder}
              onChange={handleProjectChange}
            />
          </div> */}

          <div className=" flex gap-2 items-center mt-1">
            <button
              onClick={handlePrevMonth}
              className=" outline-none border-none bg-white w-7 h-7 rounded-lg cursor-pointer flex justify-center items-center"
              style={{ border: "1px solid #d6d3d1" }}
            >
              <ArrowLeft color="#d6d3d1" />
            </button>
            <span className=" text-xs font-medium mx-1 py-[6px] px-3 rounded-lg bg-gray-100 ">
              <select
                className=" px-2 outline-none border-none text-xs font-medium bg-gray-100"
                value={currentMonth}
                onChange={handleMonthChange}
              >
                {monthList.map((month, index) => (
                  <option
                    className="text-xs font-medium bg-white"
                    key={index}
                    value={index}
                  >
                    {month}
                  </option>
                ))}
              </select>
              <select
                className=" px-2 outline-none border-none text-xs font-medium bg-gray-100"
                value={currentYear}
                onChange={handleYearChange}
              >
                {Array.from({ length: 21 }, (_, i) => currentYear - 10 + i).map(
                  (year) => (
                    <option
                      className="text-xs font-medium bg-white"
                      key={year}
                      value={year}
                    >
                      {year}
                    </option>
                  )
                )}
              </select>
            </span>
            <button
              onClick={handleNextMonth}
              className=" outline-none border-none w-7 h-7 bg-white rounded-lg cursor-pointer flex justify-center items-center"
              style={{ border: "1px solid #d6d3d1" }}
            >
              <ArrowRight color="#d6d3d1" />
            </button>
          </div>

          <div className=" flex gap-2 items-center mr-3">
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-red-600 font-semibold"
              style={{ border: "1px solid #fca5a5" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-red-300 rounded text-red-600 flex justify-center items-center">
                A
              </div>
              Absent
            </div>
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-green-600 font-semibold"
              style={{ border: "1px solid #86efac" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-green-300 rounded text-green-600 flex justify-center items-center">
                P
              </div>
              Present
            </div>
            <div
                      className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-blue-600 font-semibold"
                      style={{ border: "1px solid #119DEE" }}
                    >
                      <div className=" w-5 h-5 text-[11px] font-medium bg-blue-200 rounded text-blue-600  flex justify-center items-center">
                        V
                      </div>
                      Vacation
                    </div>
                    <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-teal-600 font-semibold"
              style={{ border: "1px solid #5eead4" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-teal-200 rounded text-teal-600 flex justify-center items-center">
                SL
              </div>
              Sick Leave
            </div>
            {/* <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-violet-600 font-semibold"
              style={{ border: "1px solid #c4b5fd" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-violet-300 rounded text-violet-600 flex justify-center items-center">
                OT
              </div>
              Over Time
            </div> */}
            {/* <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-teal-600 font-semibold"
              style={{ border: "1px solid #5eead4" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-teal-200 rounded text-teal-600 flex justify-center items-center">
                Wo
              </div>
              Week Off
            </div>
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-blue-600 font-semibold"
              style={{ border: "1px solid #93c5fd" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-blue-300 rounded text-blue-600 flex justify-center items-center">
                PL
              </div>
              Paid Leave
            </div>
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-yellow-600 font-semibold"
              style={{ border: "1px solid #fef08a" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-yellow-200 rounded text-yellow-600 flex justify-center items-center">
                H
              </div>
              Holiday
            </div>
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-sky-600 font-semibold"
              style={{ border: "1px solid #bae6fd" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-sky-200 rounded text-sky-600 flex justify-center items-center">
                HD
              </div>
              Half Day
            </div>
            <div
              className=" p-1 rounded-lg text-[11px] flex items-center gap-2 text-stone-600 font-semibold"
              style={{ border: "1px solid #d6d3d1" }}
            >
              <div className=" w-5 h-5 text-[11px] font-medium bg-stone-300 rounded text-stone-600 flex justify-center items-center">
                UL
              </div>
              Unpaid Leave
            </div> */}
          </div>
        </div>
        <div className=" w-[calc(100vw-250px)] h-[calc(100vh-200px)] overflow-x-auto">
          <div className=" w-full h-[calc(100vh-210px)]  overflow-y-auto relative ">
            {/* <table
            width={"100%"}
            className=" border-collapse auto sticky top-0 z-[99]"
            style={{ border: "1px solid #d6d3d1" }}
          >

          </table> */}

            <table
              className="w-full border-collapse table-auto relative  z-0"
              style={{ border: "1px solid #d6d3d1" }}
            >
              <thead className=" w-full  bg-gray-100 sticky top-0 z-[5] left-0">
                <tr>
                  <th className="text-left font-medium text-xs pl-2 sticky left-0 z-[5] bg-gray-100">
                    <div className="w-[300px]">Name</div>
                  </th>
                  {days.map((day, i) => (
                    <React.Fragment key={i}>
                      <th
                        className="min-w-[40px] max-w-[40px] p-1"
                        style={{
                          borderLeft: "1px solid #d6d3d1",
                          borderRight: "1px solid #d6d3d1",
                        }}
                      >
                        <div>
                          <p className=" text-[11px] font-normal">
                            {day?.monthName}
                          </p>
                          <p className=" text-xs font-semibold">
                            {day?.dateNum || "#"}
                          </p>
                          <p className=" text-[11px] font-semibold">
                            {day?.dayName || "-"}
                          </p>
                        </div>
                      </th>
                    </React.Fragment>
                  ))}
                  <th
                    className=" min-w-[60px] max-w-[60px] p-1"
                    style={{
                      borderLeft: "1px solid #d6d3d1",
                      borderRight: "1px solid #d6d3d1",
                    }}
                  >
                    <p className=" text-[12px] font-medium">Total</p>
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {employeeAttendes.map((employee, index) => (
                  <tr
                    key={index}
                    style={{
                      borderTop: "1px solid #d6d3d1",
                      borderBottom: "1px solid #d6d3d1",
                    }}
                  >
                    <td className="w-[300px] text-left text-xs py-2 pl-2 sticky bg-white left-0 z-[1]">
                      <div className="w-full h-full flex items-center gap-2 ">
                        <div className=" w-8 h-8 bg-slate-300 rounded-full flex justify-center items-center text-sm font-semibold">
                          {employee?.name?.charAt(0).toUpperCase() ||
                            employee?.userName?.charAt(0).toUpperCase() ||
                            ""}
                        </div>
                        <div>
                          <p className=" font-medium">
                            {employee?.userName || employee?.name || ""}
                          </p>
                          <p className=" font-normal text-[9px]">
                            {employee?.position || employee?.userRole || ""}
                          </p>
                        </div>
                      </div>
                    </td>
                    {employee.attendances.map((status, idx) => (
                      <td
                        className=" min-w-[40px] max-w-[40px] p-1"
                        style={{
                          borderLeft: "1px solid #d6d3d1",
                          borderRight: "1px solid #d6d3d1",
                        }}
                        key={idx}
                      >
                        {status?.status == 1 ? (
                          <Popover
                            content={
                              <>
                                <div className=" min-w-36 max-w-56">
                                  <p className=" text-[13px] font-medium">
                                    Working Details :
                                  </p>
                                  <table className=" text-xs">
                                    <tr>
                                      <td className=" py-0.5">Working Hour</td>
                                      <td className=" px-1">:</td>
                                      <td className=" py-0.5">
                                        {status?.working_hours || "0"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className=" py-0.5">Over Time</td>
                                      <td className=" px-1">:</td>
                                      <td className=" py-0.5">
                                        {status?.over_time || "0"}
                                      </td>
                                    </tr>
                                    {status?.comments != "" && (
                                      <tr>
                                        <td className=" py-0.5">Comments</td>
                                        <td className=" px-1">:</td>
                                        <td className=" py-0.5">
                                          {status?.comments || ""}
                                        </td>
                                      </tr>
                                    )}
                                  </table>
                                  {status?.comments ? (
  <div className="flex gap-2">
  <span
    onClick={() => OpenFunction(status?.id, status?.comments)}
    className="cursor-pointer text-blue-500"
  >
    <EditIcon />
  </span>
  <span
    onClick={() => handleDeleteComment(status?.id)}
    className="cursor-pointer text-red-500"
  >
    <DeleteIcon />
  </span>
</div>

) : (
  <button
    className="text-[10px] px-2 py-1 my-2 bg-textColor-main text-white rounded-lg"
    onClick={() => OpenFunction(status?.id)}
  >
    Add Comment
  </button>
)}
                                </div>
                              </>
                            }
                          >
                            <div
                              className={`w-full h-full ${
                                status?.status == 2
                                  ? "bg-red-300 text-red-600"
                                  : status?.status == 1
                                  ? "bg-green-300 text-green-600"
                                  : status?.status == 0
                                  ? "bg-violet-300 rounded text-violet-600"
                                  : ""
                              } rounded flex cursor-pointer justify-center items-center text-xs font-medium py-2`}
                            >
                              {status?.status == 2 ? (
                                <p>A</p>
                              ) : status?.status == 1 ? (
                                <p>P</p>
                              ) : status?.status === 0 ? (
                                <p>-</p>
                              ) : (
                                ""
                              )}
                            </div>
                          </Popover>
                        ) : (
                          <Popover
                            content={
                              <>
                                <div className=" min-w-24 max-w-56">
                                {status?.comments ? (
                                          <table className=" text-xs">
                                              <tr>
                                                <td className=" py-0.5">Comments</td>
                                                <td className=" px-1">:</td>
                                                <td className=" py-0.5">
                                                  {status?.comments || ""}
                                                </td>
                                              </tr>
                                            
                                          </table>):(
                                          
                                            <button 
                                            className="text-[10px] px-2 py-1 my-2 bg-textColor-main text-white rounded-lg"
                                            onClick={()=>{OpenFunction(status?.id)}}
                                            >
                                              Add Comment
                                            </button>
                                          )}
                                </div>
                              </>
                            }
                          >
                            <div
                              className={`w-full h-full 
                          ${
                            status?.status == 2
                              ? "bg-red-300 text-red-600"
                              : status?.status == 1
                              ? "bg-green-300 text-green-600"
                              : status?.status == 0
                              ? "bg-violet-300 rounded text-violet-600"
                              : ""
                          } 
                          rounded flex justify-center items-center text-xs font-medium py-2`}
                            >
                              {status?.status == 2 ? (
                                <p>A</p>
                              ) : status?.status == 1 ? (
                                <p>P</p>
                              ) : status?.status === 0 ? (
                                <p>-</p>
                              ) : (
                                ""
                              )}
                            </div>
                          </Popover>
                        )}
                      </td>
                    ))}
                    <td
                      className=" min-w-[60px] max-w-[60px] p-1 text-xs text-center"
                      style={{
                        borderLeft: "1px solid #d6d3d1",
                        borderRight: "1px solid #d6d3d1",
                      }}
                    >
                      {`${employee?.working_days}/${employee?.attendances.length}`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TimesheetLayout>
      <Modal
        open={openAll}
        title={`Add Comments`}
        width={"35%"}
        className="my-modal"
        centered
        onCancel={CloseFunction}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              width="w-full"
             new_width="w-full"
            />
            <div className=" w-full px-6">
            <Button
              htmlType="submit"
              size="large"
              className="w-full bg-[#048178] text-white  mx-auto"
            >
              Submit
            </Button>
            </div>
        </form>
      </Modal>
    </>
  );
}

export default TimesheetsIndex;
